// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3Sq2i","active":"NavigationItem_active__26h4C"};